import { createSlice } from "@reduxjs/toolkit";

const authSlice = createSlice({
  name: "auth",
  initialState: {
    user: null,
    token: null,
    loggedIn: false,
    loginData: null,
  },
  reducers: {
    loginData: (state, action) => {
      state.loginData = action.payload;
    },
    loginSuccess(state, action) {
      state.token = action.payload.access_token;
      state.user = action.payload;
      state.loggedIn = true;
    },
    logout(state) {
      state.loggedIn = false;
      state.user = null;
      state.token = null;
      state.loginData = null;
    },
  },
});

export const { loginSuccess, logout, loginData } = authSlice.actions;
export default authSlice.reducer;
